import './brand.css';

import logoColorUrl from '../../ResiCraft_Logo_Color.svg?url';
import logoWhiteUrl from '../../ResiCraft_Logo_White.svg?url';
import logoBlackUrl from '../../ResiCraft_Logo_Black.svg?url';
import sygnetColorUrl from '../../ResiCraft_Sygnet_Color.svg?url';

export type BrandTone = 'color' | 'white' | 'black';

interface BrandLogoProps {
  tone?: BrandTone;
  compact?: boolean;
  className?: string;
}

export function BrandLogo({ tone = 'white', compact = false, className }: BrandLogoProps) {
  const logoSrc = tone === 'color' ? logoColorUrl : tone === 'black' ? logoBlackUrl : logoWhiteUrl;

  return (
    <div className={['brand-logo', compact && 'brand-logo--compact', className].filter(Boolean).join(' ')}>
      <img className="brand-logo__wordmark" src={logoSrc} alt="ResiCraft" decoding="async" />
    </div>
  );
}

interface BrandMarkProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function BrandMark({ size = 'md', className }: BrandMarkProps) {
  return (
    <div className={['brand-mark', `brand-mark--${size}`, className].filter(Boolean).join(' ')}>
      <img className="brand-mark__image" src={sygnetColorUrl} alt="" aria-hidden="true" decoding="async" />
    </div>
  );
}